/** Popover (shadcn/ui, adapted; Radix Popover): a click-opened, non-modal panel anchored to its trigger. */
import { Popover as PopoverPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.js';

export function Popover(props: ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

export function PopoverTrigger(props: ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

export function PopoverContent({ className, align, sideOffset, ...props }: ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align ?? 'center'}
        sideOffset={sideOffset ?? 4}
        className={cn('z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden', className)}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
